'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dSimple$002dText$002dSearch from "./mealorama.-Simple-Text-Search.js";
var $p;
/** @constructor */
function $c_Lmealorama_SimpleTextSearch$() {
}
export { $c_Lmealorama_SimpleTextSearch$ as $c_Lmealorama_SimpleTextSearch$ };
$p = $c_Lmealorama_SimpleTextSearch$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_SimpleTextSearch$;
/** @constructor */
function $h_Lmealorama_SimpleTextSearch$() {
}
export { $h_Lmealorama_SimpleTextSearch$ as $h_Lmealorama_SimpleTextSearch$ };
$h_Lmealorama_SimpleTextSearch$.prototype = $p;
$p.m = (function() {
  return "SimpleTextSearch";
});
$p.aSw = (function(x$0) {
  return new $j_mealorama$002e$002dSimple$002dText$002dSearch.$c_Lmealorama_SimpleTextSearch(x$0.g(0), (x$0.g(1) | 0), (x$0.g(2) | 0), x$0.g(3));
});
var $d_Lmealorama_SimpleTextSearch$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_SimpleTextSearch$, "mealorama.SimpleTextSearch$", ({
  GY: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_SimpleTextSearch$ as $d_Lmealorama_SimpleTextSearch$ };
var $n_Lmealorama_SimpleTextSearch$;
function $m_Lmealorama_SimpleTextSearch$() {
  if ((!$n_Lmealorama_SimpleTextSearch$)) {
    $n_Lmealorama_SimpleTextSearch$ = new $c_Lmealorama_SimpleTextSearch$();
  }
  return $n_Lmealorama_SimpleTextSearch$;
}
export { $m_Lmealorama_SimpleTextSearch$ as $m_Lmealorama_SimpleTextSearch$ };
//# sourceMappingURL=mealorama.-Simple-Text-Search$.js.map
